import { Helmet } from "react-helmet-async";

const SITE = process.env.REACT_APP_SITE_URL || "https://creatorintelligencetube.com";
const DEFAULT_IMAGE = "https://images.unsplash.com/photo-1665186096425-45134ba4ddda?w=1200&h=630&fit=crop";

export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
  keywords,
  jsonLd,
  breadcrumbs,
}) {
  const url = `${SITE}${path}`;
  const fullTitle = title
    ? `${title} · Creator Intelligence Tube`
    : "Creator Intelligence Tube | AI-Powered YouTube Analytics Platform";

  const graphs = [];
  if (breadcrumbs && breadcrumbs.length) {
    graphs.push({
      "@type": "BreadcrumbList",
      itemListElement: breadcrumbs.map((b, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: b.name,
        item: `${SITE}${b.path}`,
      })),
    });
  }
  if (jsonLd) graphs.push(...(Array.isArray(jsonLd) ? jsonLd : [jsonLd]));

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Creator Intelligence Tube" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {graphs.length > 0 && (
        <script type="application/ld+json">
          {JSON.stringify({ "@context": "https://schema.org", "@graph": graphs })}
        </script>
      )}
    </Helmet>
  );
}
